/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_View_ListInputs */

const cs_gallery_view_list = /** @type {(inputs: Gallery_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam`)
};

const en_gallery_view_list = /** @type {(inputs: Gallery_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List`)
};

/**
* | output |
* | --- |
* | "List" |
*
* @param {Gallery_View_ListInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_view_list = /** @type {((inputs?: Gallery_View_ListInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_View_ListInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_view_list(inputs)
	return cs_gallery_view_list(inputs)
});